/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { AppService } from '@services/app/app.service';
import { HttpClient } from '@angular/common/http';
import { LabelItemDTO } from '@api/models/label-item.dto';
import { mergeMap, map } from 'rxjs/operators';
import { ApiService } from '@api/services/api/api.service';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LabelsService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private appService: AppService,
    private translate: TranslateService
  ) {}

  /**
   * carica le labels pubbliche
   */
  loadOpenLabels(): Observable<void> {
    const url = this.appService.getConfig().labels.openLabelsUrl;

    if (!url) {
      return of([]).pipe(map(() => {}));
    }

    return this.http.get<LabelItemDTO[]>(url).pipe(
      mergeMap(labels => this.setTranslation(labels || [])),
      map(() => {})
    );
  }

  /**
   * carica le labels
   */
  loadLabels(): Observable<void> {
    return this.apiService.getLabels().pipe(
      mergeMap(res => this.setTranslation(res.labels || [])),
      map(() => {})
    );
  }

  /**
   * restituisce traduzione per la key richiesta;
   * assicurarsi di usare il metodo quando le label sono caricate
   */
  getLabel(key: string, interpolateParams?: { [key: string]: string }): string {
    return this.translate.instant(key, interpolateParams);
  }

  /**
   * controlla se la label richiesta esiste
   */
  doesLabelExists(key: string): boolean {
    return this.getLabel(key) !== key;
  }

  /**
   * imposta le traduzioni in base alle label caricate
   */
  private setTranslation(list: LabelItemDTO[]): Observable<boolean> {
    const lang = this.getUserLang();
    const labels = this.listToMap(list);

    this.translate.setTranslation(lang, labels, true);
    this.translate.setDefaultLang(lang);

    return this.translate.use(lang).pipe(map(() => true));
  }

  /**
   * converte la lista di label in una mappa
   */
  private listToMap(labelList: LabelItemDTO[]): { [key: string]: string } {
    const labelMap = {};

    if (!Array.isArray(labelList)) {
      return labelMap;
    }

    labelList.forEach(label => {
      labelMap[label.key] = label.value;
    });

    return labelMap;
  }

  /**
   * definisce lal lingua impostata dall'utente
   */
  private getUserLang(): string {
    return this.translate.getBrowserCultureLang();
  }
}
